import { api } from "@/apiInstance";
import { endpoints as vixiEndpoints, EndpointsDict } from "@/endpoints";
import { useAuthStore } from "@/store/auth.state";
import { useMutation } from "@tanstack/react-query";
import { LoginRequest, LoginResponse } from "@vixi/types";

export const useLogin = (endpoints: EndpointsDict<"login", string> = vixiEndpoints) => {
  const { setTokenData } = useAuthStore();

  const mutation = useMutation({
    mutationFn: async (body: LoginRequest) => {
      const response = await api.post<LoginResponse>(endpoints.login as any, body);
      const data = response.data;

      setTokenData(data);

      return data;
    },
  });

  return mutation;
};
